import { useTranslations } from 'next-intl';
import Container from '../Container';
import { BarStoreRecord } from '../utils';
import StoreItem from './StoreItem';
import { useState } from 'react';

interface Props {
  stores: BarStoreRecord[];
  selectedStore?: BarStoreRecord;
  onItemClick: (item: BarStoreRecord) => void;
}

export default function StoreList({
  stores,
  selectedStore,
  onItemClick,
}: Props) {
  const t = useTranslations('bar');

  return (
    <ul className="pl-0 ml-0 pt-6 grid grid-cols-1 3xl:grid-cols-2 gap-4">
      {stores.map((store) => (
        <StoreItem
          store={store}
          isSelected={selectedStore?.id === store.id}
          onClick={onItemClick}
        />
      ))}
    </ul>
  );
}
